import * as React from "react";
import {
  required,
  SelectInput,
  TextInput,
  DateInput,
  BooleanInput,
  AutocompleteInput,
} from "react-admin";

const ukraineRegions = [
  { id: "Вінницька", name: "Вінницька" },
  { id: "Волинська", name: "Волинська" },
  { id: "Дніпропетровська", name: "Дніпропетровська" },
  { id: "Донецька", name: "Донецька" },
  { id: "Житомирська", name: "Житомирська" },
  { id: "Закарпатська", name: "Закарпатська" },
  { id: "Запорізька", name: "Запорізька" },
  { id: "Івано-Франківська", name: "Івано-Франківська" },
  { id: "Київська", name: "Київська" },
  { id: "Кіровоградська", name: "Кіровоградська" },
  { id: "Луганська", name: "Луганська" },
  { id: "Львівська", name: "Львівська" },
  { id: "Миколаївська", name: "Миколаївська" },
  { id: "Одеська", name: "Одеська" },
  { id: "Полтавська", name: "Полтавська" },
  { id: "Рівненська", name: "Рівненська" },
  { id: "Сумська", name: "Сумська" },
  { id: "Тернопільська", name: "Тернопільська" },
  { id: "Харківська", name: "Харківська" },
  { id: "Херсонська", name: "Херсонська" },
  { id: "Хмельницька", name: "Хмельницька" },
  { id: "Черкаська", name: "Черкаська" },
  { id: "Чернівецька", name: "Чернівецька" },
  { id: "Чернігівська", name: "Чернігівська" },
  { id: "м. Київ", name: "м. Київ" },
];

const CreateClient = () => (
  <>
    <TextInput
      sx={{
        width: "20%",
        "@media (max-width:900px)": {
          width: "100%",
        },
      }}
      inputProps={{ maxLength: 64 }}
      source="middle_name"
      validate={[required()]}
    />
    <SelectInput
      sx={{
        width: "20%",
        "@media (max-width:900px)": {
          width: "100%",
        },
      }}
      label="resources.Client.fields.sex.name"
      choices={[
        { id: "female", name: "resources.Client.fields.sex.female" },
        {
          id: "male",
          name: "resources.Client.fields.sex.male",
        },
      ]}
      optionText="name"
      optionValue="id"
      source="sex"
      validate={[required()]}
    />
    <AutocompleteInput
      sx={{
        width: "20%",
        "@media (max-width:900px)": {
          width: "100%",
        },
      }}
      source="region"
      choices={ukraineRegions}
      inputText={(record) => record.name}
      optionText="name"
      optionValue="id"
      debounce={10}
      filterToQuery={(searchText) => ({ name: searchText })}
      alwaysOn
      resettable="true"
    />
    <DateInput
      sx={{
        width: "20%",
        "@media (max-width:900px)": {
          width: "100%",
        },
      }}
      source="date_of_birth"
      validate={[required()]}
    />
    <BooleanInput
      source="terms_agreement_confirm"
      defaultValue={true}
      validate={[required()]}
    />
    <TextInput
      sx={{
        width: "20%",
        "@media (max-width:900px)": {
          width: "100%",
        },
      }}
      inputProps={{ maxLength: 64 }}
      source="id"
      validate={[required()]}
    />
  </>
);

export default CreateClient;
